
import css from 'styled-jsx/css';

export default css.global`/* @styled-jsx=global */

.recorded-webinars {
  grid-column: content;
  padding: 40px 0;
  max-width: $container-max-width;
  width: 100%;
  margin: 0 auto;

  > * + * {
    margin-top: 2em;
  }

  &__list {
    display: grid;
    grid-template-columns: repeat(1, 1fr);
    grid-gap: 50px;
  }
}

.recorded-webinar {
  > * + * {
    margin-top: 1em;
  }

  &__thumbnail {
    position: relative;
    text-decoration: none;
    color: inherit;
    display: block;
  }

  picture,
  img {
    border-radius: 5px;
  }

  &__duration {
    position: absolute;
    top: 10px;
    right: 10px;
    padding: 5px 10px;
    background-color: #fff;
    color: $blue-legacy;
    border-radius: 5px;
    box-shadow: 0 0 6px rgba(0, 0, 0, 0.4);
  }
}

.recorded-webinars__header {
  display: flex;
  flex-direction: column;
  margin-bottom: 50px;
}

.recorded-webinars__right-header {
  display: grid;
  grid-gap: 20px;
}

.recorded-webinars__heading {
  margin-bottom: 20px;

  span {
    font-size: 36px;
  }
}

.recorded-webinar__description {
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
}

.recorded-webinars__dropdown {
  display: flex;
  flex-direction: column;

  li + li {
    padding: 5px 0 0;
  }

  .dropdown__wrap {
    margin-top: 10px;
  }
}

.recorded-webinars__category {
  margin-bottom: 80px;

  &:last-of-type {
    margin-bottom: 0;
  }
}

.recorded-webinars__search {
  width: 100%;
  grid-row: 1 / -1;

  .search__field-input {
    padding: 6px 20px;
  }

  .search__field-input-wrap {
    position: relative;
    bottom: auto;
    opacity: 1;
    pointer-events: all;
  }

  .search__opener {
    display: none;
  }
}

.recorded-webinars__category__title {
  margin-bottom: 20px;
}

@include media-query(tablet) {
  .recorded-webinars {
    padding: 60px 0;
  }

  .recorded-webinars__category {
    margin-bottom: 100px;
  }

  .recorded-webinars__category__title {
    margin-bottom: 24px;
  }

  .recorded-webinars__list {
    grid-template-columns: repeat(2, 1fr);
  }
}

@include media-query(laptop) {
  .recorded-webinars__header {
    align-items: center;
    flex-direction: row;
    justify-content: space-between;
    margin-bottom: 70px;
  }

  .recorded-webinars__right-header {
    grid-auto-flow: column;
  }

  .recorded-webinars__heading {
    margin-bottom: 0;
  }

  .recorded-webinars__dropdown {
    flex-direction: row;
    align-items: center;

    > * + * {
      padding: 0 0 0 20px;
    }

    .dropdown__wrap {
      margin-top: 0;
    }
  }

  .recorded-webinars__search {
    width: 252px;
  }
}

@include media-query(desktop) {
  .recorded-webinars__list {
    grid-template-columns: repeat(3, 1fr);
  }
}
`